import tagTester from './_tagTester.js';

export default tagTester('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isWeakSet.js
// module id = 1585
// module chunks = 106